export const STATUS_BLUE = '#1267b4';
